var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsegurameLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.702,
    height: 44.802,
    viewBox: "0 0 236.702 44.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15046",
    "data-name": "Grupo 15046",
    transform: "translate(-70.477 -227.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15046-2",
    "data-name": "Grupo 15046",
    transform: "translate(70.477 227.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36398",
    "data-name": "Trazado 36398",
    d: "M85.192,239.92,92.6,257.194,84.61,275.8a3.539,3.539,0,0,1-3.241,2.14l-7.34.019a3.539,3.539,0,0,1-3.26-4.937l14.346-33.288Z",
    transform: "translate(-70.477 -233.16)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36399",
    "data-name": "Trazado 36399",
    d: "M114.41,230.409l-.237-.551a3.538,3.538,0,0,0-3.25-2.14h-7.278a3.538,3.538,0,0,0-3.25,2.14l-.237.551a3.5,3.5,0,0,0,.184,2.246l6.942,16.179,6.943-16.179A3.5,3.5,0,0,0,114.41,230.409Z",
    transform: "translate(-83.873 -227.718)",
    fill: "#a01779"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15047",
    "data-name": "Grupo 15047",
    transform: "translate(126.3 238.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36400",
    "data-name": "Trazado 36400",
    d: "M186.949,264.052h-8.515l-1.409,4.033h-4.5l7.687-21.2H185.2l7.687,21.2h-4.533Zm-4.258-12.25-3.093,8.854h6.186Z",
    transform: "translate(-172.523 -246.889)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36401",
    "data-name": "Trazado 36401",
    d: "M220.756,271.773c-4.257,0-7.228-2.456-7.412-5.58h4.318a2.811,2.811,0,0,0,3.063,2.245c1.685,0,2.6-.758,2.6-1.729,0-3-9.586-1.091-9.586-7.247,0-2.79,2.511-5.034,6.708-5.034,4.1,0,6.585,2.214,6.829,5.549h-4.1c-.122-1.3-1.164-2.184-2.848-2.184-1.593,0-2.42.637-2.42,1.608,0,3.063,9.4,1.153,9.525,7.308C227.433,269.59,224.891,271.773,220.756,271.773Z",
    transform: "translate(-191.014 -250.304)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36402",
    "data-name": "Trazado 36402",
    d: "M252.041,271.773c-4.932,0-8.515-3.4-8.515-8.672,0-5.307,3.492-8.673,8.515-8.673,4.9,0,8.361,3.305,8.361,8.309a9.769,9.769,0,0,1-.122,1.637h-12.4a3.952,3.952,0,0,0,4.073,3.881,3.5,3.5,0,0,0,3.4-2.032h4.625A7.879,7.879,0,0,1,252.041,271.773Zm-4.135-10.249h8.055a3.756,3.756,0,0,0-4.043-3.609A3.927,3.927,0,0,0,247.906,261.524Z",
    transform: "translate(-204.685 -250.304)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36403",
    "data-name": "Trazado 36403",
    d: "M285.825,254.428a6.661,6.661,0,0,1,5.6,2.668v-2.4h4.319v16.92c0,4.549-2.818,8.157-8.392,8.157-4.778,0-8.116-2.365-8.546-6.216h4.258c.429,1.516,2.021,2.517,4.166,2.517,2.358,0,4.2-1.334,4.2-4.458v-2.608a6.713,6.713,0,0,1-5.6,2.759c-4.319,0-7.749-3.487-7.749-8.733S281.506,254.428,285.825,254.428Zm1.1,3.73c-2.3,0-4.472,1.7-4.472,4.882s2.175,5,4.472,5c2.358,0,4.5-1.759,4.5-4.942S289.286,258.158,286.928,258.158Z",
    transform: "translate(-220.335 -250.304)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36404",
    "data-name": "Trazado 36404",
    d: "M333.948,271.726H329.63V269.6a6.283,6.283,0,0,1-5.054,2.335c-3.951,0-6.8-2.547-6.8-7.156v-9.855h4.288v9.249c0,2.7,1.5,4.154,3.767,4.154,2.328,0,3.8-1.455,3.8-4.154v-9.249h4.318Z",
    transform: "translate(-238.318 -250.53)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36405",
    "data-name": "Trazado 36405",
    d: "M359.359,271.525h-4.288v-16.8h4.288v2.608a5.9,5.9,0,0,1,5.207-2.85v4.457h-1.133c-2.542,0-4.074.97-4.074,4.215Z",
    transform: "translate(-255.211 -250.329)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36406",
    "data-name": "Trazado 36406",
    d: "M383.427,254.428a6.734,6.734,0,0,1,5.605,2.668v-2.4h4.319v16.8h-4.319v-2.456a6.714,6.714,0,0,1-5.636,2.729c-4.288,0-7.719-3.487-7.719-8.733S379.108,254.428,383.427,254.428Zm1.1,3.73c-2.3,0-4.472,1.7-4.472,4.882s2.175,5,4.472,5c2.358,0,4.5-1.759,4.5-4.942S386.888,258.158,384.53,258.158Z",
    transform: "translate(-264.545 -250.304)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36407",
    "data-name": "Trazado 36407",
    d: "M439.4,262.246c0-2.668-1.5-4.063-3.767-4.063-2.3,0-3.8,1.395-3.8,4.063v9.279h-4.288v-9.279c0-2.668-1.5-4.063-3.767-4.063-2.328,0-3.829,1.395-3.829,4.063v9.279H415.66v-16.8h4.288v2.032a6.2,6.2,0,0,1,4.993-2.274,6.51,6.51,0,0,1,5.972,3.214,6.731,6.731,0,0,1,5.819-3.214c4.074,0,6.953,2.547,6.953,7.186v9.855H439.4Z",
    transform: "translate(-282.656 -250.329)",
    fill: "#0099b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36408",
    "data-name": "Trazado 36408",
    d: "M480.844,271.773c-4.931,0-8.515-3.4-8.515-8.672,0-5.307,3.492-8.673,8.515-8.673,4.9,0,8.361,3.305,8.361,8.309a9.831,9.831,0,0,1-.122,1.637h-12.4a3.952,3.952,0,0,0,4.073,3.881,3.5,3.5,0,0,0,3.4-2.032h4.624A7.878,7.878,0,0,1,480.844,271.773Zm-4.135-10.249h8.056a3.757,3.757,0,0,0-4.043-3.609A3.927,3.927,0,0,0,476.709,261.524Z",
    transform: "translate(-308.325 -250.304)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36409",
    "data-name": "Trazado 36409",
    d: "M136.391,269.78l-16.008-37.212a3.636,3.636,0,0,1-.188,2.293l-6.923,16.132,9.278,21.565a3.539,3.539,0,0,0,3.241,2.14l7.34.019A3.539,3.539,0,0,0,136.391,269.78Z",
    transform: "translate(-19.385 -2.197)",
    fill: "#0099b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsegurameLogo);
export default __webpack_public_path__ + "static/media/AsegurameLogo.4f2f8809a0895487807675fc42e8ac68.svg";
export { ForwardRef as ReactComponent };